/* eslint-disable no-unused-vars */
import styled, { css } from 'styled-components';
import { Palette } from 'config';

export const Update = styled.div`
  min-height: 80px;
  width: 100%;
  display: flex;
  flex-direction: column;
  border-bottom: ${({ isLastElement }) => (isLastElement ? 'none' : '1px solid')};
  border-color: ${Palette.PrimaryGray._200};
  padding-right: 0;
  padding-bottom: 16px;
  margin-bottom: 16px;
`;

export const Title = styled.div`
  color: ${Palette.PrimaryGray._900};
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  width: 100%;
`;

export const CampaignName = styled.div`
  margin-bottom: 8px;
`;

export const SmallTitle = styled.div`
  color: ${Palette.PrimaryGray._500};
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
`;
